import { paginationActions, requestActions } from "./utils";

export const BUNDLE = requestActions("Bundle/Item");
export const BUNDLE_LIST = requestActions("Bundle/List");

export const PAGINATION = {
  ...paginationActions("Bundle/Paginate"),
  LANGUAGE: "Bundle/Paginate/Language",
  TAGS: "Bundle/Paginate/Tags",
};